package uz.ferro.shop.model

data class OrderFilter(
    val searchQuery: String = ""
)